"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var addRems = exports.addRems = function addRems(x, y) {
  return parseFloat(x, 10) + parseFloat(y, 10) + "rem";
};
//# sourceMappingURL=helpers.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/toolkit/helpers.js